import React, { useEffect, useContext } from "react";
import "../FinancialCalculators.css";
import { useMediaQuery } from "@mui/material";
import LoanEMICalculators from "./LoanEmiCalculators/LoanEMICalculators";
import DebtConsolidations from "./DebtConsolidations/DebtConsolidations";
import RefinanceCalculators from "./RefinanceCalculators/RefinanceCalculators";
import EligibilityCalculators from "./EligibilityCalculators/EligibilityCalculators";
import FinancialResources from "./FinancialResources/FinancialResources";
import BalanceTransferCalculators from "./BalanceTransferCalculators/BalanceTransferCalculators";
import MetadataContext from "../../Pages/MetadataContext";
import { Link } from "react-router-dom";
const FinancialCalculators = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setMetadata } = useContext(MetadataContext);

  useEffect(() => {
    setMetadata({
      pageTitle: "Financial Calculators for Smart Decisions | Minemi.ai",
      pageDescription:
        "Simplify your financial planning with Minemi.ai's advanced financial calculators. Calculate EMIs, loans, investments, and more with ease and accuracy.",
      pageKeywords: "financial calculators,financial calculator online",
      canonicalUrl: "https://minemi.ai/calculators/",
    });
  }, [setMetadata]);

  return (
    <>
      <div id="financial_calculator__container" className="w-100">
        {/* Hero Section Starts Here */}
        <section id="hero_section" className="w-100">
          <p className="pages_links bg-transparent links ">
            <Link
              to="/"
              underline="hover"
              className="bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Home
            </Link>
            &nbsp;
            <span
              className="d-none d-md-inline bg-transparent ps-1 px-1 "
              style={{
                color: "#59266D",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              &gt;
            </span>
            &nbsp;
            <Link
              to="/calculators"
              underline="hover"
              className="d-none d-md-inline fw-bold bg-transparent archivo"
              style={{
                fontSize: isSmallScreen ? 13 : 16,
                color: "#59266d",
                cursor: "pointer",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              Calculators
            </Link>
            &nbsp;
          </p>
          <div
            id="hero_container"
            className="d-flex flex-column flex-md-row align-items-center justify-content-between w-100"
          >
            <div id="" className="hero-headings pe-auto pe-lg-5">
              <h1>Minemi Financial Calculators</h1>
              <p
                sx={{
                  fontSize: { xs: 20, lg: 22, xl: 24 },
                  color: "#1F1F1F",
                  fontWeight: 400,
                  lineHeight: { xs: "23px", lg: "25px", xl: "30px" },
                  fontFamily: "Archivo",
                  backgroundColor: "transparent",
                  textAlign: "start",
                }}
                className=" mt-2"
              >
                Explore Our Comprehensive Range of Calculators to Make Informed
                Financial Choices
              </p>
            </div>
            <div style={{ backgroundColor: "transparent" }}>
              <img
                src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hero_img-1745056661887.webp"
                alt="hero_img"
                className="hero_img"
              />
            </div>
          </div>
        </section>
        {/* Hero Section Ends Here */}

        <section id="main-section" className="d-flex flex-column gap-5">
          {/* Welcome Line */}
          <div
            className="financial_heading__container "
            style={{ backgroundColor: "transparent" }}
          >
            <p className="financial_subheading">
              Welcome to Minemi’s one-stop destination for financial
              calculators! Whether you’re planning to consolidate debt,
              refinance a loan, calculate EMIs, or check your loan eligibility,
              we have all the tools you need. Each calculator is designed to
              provide accurate insights and help you make better financial
              decisions, ensuring you save time, effort, and money.
            </p>
            <p className="financial_subheading_two">
              Explore our categories below to find the calculator that meets
              your specific needs, and take the first step toward smarter
              financial planning.
            </p>
          </div>
          {/* Calcualtors Pages Section Starts here */}
          <section
            id="calcualtor_pages__containers"
            style={{ backgroundColor: "transparent" }}
            className="mt-4"
          >
            <div
              className="d-flex flex-column gap-5"
              style={{ backgroundColor: "transparent" }}
            >
              <LoanEMICalculators />
              <EligibilityCalculators />
              <DebtConsolidations />
              <RefinanceCalculators />
              <BalanceTransferCalculators />
              <FinancialResources />
            </div>
          </section>
          {/* Calcualtors Pages Section Ends here */}
        </section>
      </div>
    </>
  );
};

export default FinancialCalculators;
